import Router from 'vue-router';
import Vue from 'vue';
import system from './system';
import { Toast } from 'vant';

Vue.use(Router);

const router = new Router({
  base: process.env.NODE_ENV === 'production' ? '/task/' : '/',
  routes: system,
  // mode: 'history',
  mode: 'hash'
});

const loadingToast = Toast.loading({
  overlay: true,
  message: '加载中...'
});

router.beforeEach((to, from, next) => {
  // loadingToast.open();
  // console.log(location, 'location')
  // if (!localStorage.getItem('jryjShop_token') && (to.path == '/shop_home' || to.path == '/shop_list' || to.path == '/shop_tj' || to.path == '/shop_hx_list')) {
  //     console.log('shop_home')
  //     localStorage.setItem('isShop', 'true')
  //     next({ path: '/login', query: { path: to.name, ...to.query } });
  // } else if (!localStorage.getItem('jryj_token') && to.path != '/login' && to.path != '/shop_home' && to.path != '/shop_list' && to.path != '/shop_tj' && to.path != '/shop_hx_list') {
  //     console.log('home location')
  //     localStorage.setItem('isShop', 'false')
  //     next({ path: '/login', query: { path: to.name, ...to.query } });
  // } else {
  next();
  // }
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
  loadingToast.clear();
});
export default router;
